import { User, Gavel, Landmark, Trophy, Handshake } from "lucide-react";

const items = [
  {
    icon: Gavel,
    title: "Disputes-First DNA",
    desc: "Our foundation lies in litigation, arbitration, and dispute resolution, enabling us to provide advice informed by real-world enforcement and courtroom experience.",
  },
  {
    icon: User,
    title: "Partner-Led Representation",
    desc: "Every matter receives direct involvement from the firm's partners, ensuring strategic oversight and personalized client engagement.",
  },
  {
    icon: Landmark,
    title: "Government & Regulatory Experience",
    desc: "Our experience in representing government bodies and navigating regulatory frameworks provides valuable insight into public law, investigations, and enforcement proceedings.",
  },
  {
    icon: Trophy,
    title: "Sports Law & Governance Expertise",
    desc: "LexSant offers a dedicated sports law practice combining legal advisory, governance, commercial strategy, and athlete representation for the evolving sports industry.",
  },
  {
    icon: Handshake,
    title: "Commercially Practical Solutions",
    desc: "We understand that effective legal advice must align with business objectives, risk management priorities, and commercial realities.",
  },
];

export default function WhyChoose() {
  return (
    <section data-testid="why-choose-section" className="py-24 md:py-32 bg-navy-dark">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16 animate-on-scroll">
          <p className="text-sm tracking-[0.3em] uppercase text-gold font-body font-medium mb-4">
            Why LexSant
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight text-white">
            Built different. By design.
          </h2>
          <div className="h-px w-16 bg-gold/40 mt-6" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <div
              key={item.title}
              data-testid={`why-choose-card-${i}`}
              className={`animate-on-scroll group bg-navy-base border border-gold/10 p-8 hover:border-gold/40 transition-all duration-500 ${
                i === 2 ? "lg:row-span-2 flex flex-col lg:justify-center lg:p-10" : ""
              }`}
            >
              <item.icon className={`text-gold mb-5 group-hover:scale-110 transition-transform duration-300 ${i === 2 ? "w-8 h-8 lg:mb-8" : "w-6 h-6"}`} />
              <h3 className={`font-heading text-white tracking-tight mb-2 ${i === 2 ? "text-xl lg:text-2xl lg:mb-4" : "text-xl"}`}>{item.title}</h3>
              <p className={`text-gray-400 font-body ${i === 2 ? "text-sm lg:text-base leading-relaxed lg:leading-loose" : "text-sm leading-relaxed"}`}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
